(() => {
  'use strict';
  const cache = new Map(), variants = new Map();
  const handles = ['bockmann-fabrikstillval-konfigurator-2026','bockmann-slapvagnar-fabrikstillval-2026','bockmann-fargtillval-med-bilder','bockmann-utrustning-med-bilder','portax-l-sr-pristillagg'];
  const currency = () => window.Shopify?.currency?.active || 'SEK';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'sv-SE', {style:'currency', currency:currency(), minimumFractionDigits:2, maximumFractionDigits:2}).format(cents / 100);
  async function loadProduct(handle, fresh = false) {
    const key = currency() + ':' + handle;
    if (fresh) cache.delete(key);
    if (!cache.has(key)) cache.set(key, (async () => {
      let page = 1, pages = 1; const found = new Map();
      do {
        const url = new URL((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(handle), location.origin);
        url.searchParams.set('view','equistore-prices'); url.searchParams.set('page',String(page));
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const r = await fetch(url, {headers:{Accept:'text/html'},cache:'no-store'});
        if (!r.ok) throw Error('Priserna kunde inte hämtas. Ladda om sidan och försök igen.');
        const data = await r.json();
        if (data.currency !== currency() || data.page !== page || !Array.isArray(data.variants)) throw Error('Valutan har ändrats. Ladda om sidan innan du beställer.');
        pages = data.pages;
        if (!Number.isInteger(pages) || pages < 1 || pages > 20) throw Error('Priserna behöver kontrolleras.');
        data.variants.forEach(v => { if (!Number.isSafeInteger(v.price) || v.price < 0) throw Error('Ogiltigt pris.'); found.set(String(v.id),v); });
        page++;
      } while (page <= pages);
      found.forEach((v,id) => variants.set(id,v));
      return found;
    })().catch(e => {cache.delete(key);throw e;}));
    return cache.get(key);
  }
  const price = id => {const v=variants.get(String(id));if(!v)throw Error('Tillvalets pris kunde inte kontrolleras. Ladda om sidan eller begär offert.');return v.price;};
  const baseId = root => root.dataset.variant || root.dataset.mainVariant;
  const reductions = root => JSON.parse(root.querySelector('[data-base-variants]')?.textContent || '{}');
  const priceMap = root => JSON.parse(root.querySelector('[data-price-map]')?.textContent || '{}');
  function option(root, o, el = o) {
    const sourcePrice = el.dataset.includedBy ? 0 : Number(o.dataset.price || 0);
    let local = 0, id = o.dataset.cartVariant || priceMap(root)[String(sourcePrice)];
    let unpriced = !el.dataset.includedBy && o.dataset.unpriced === 'true';
    if (!unpriced && sourcePrice !== 0) {
      try {local=sourcePrice>0?price(id):price(reductions(root)[String(sourcePrice)])-price(baseId(root));}
      catch {unpriced=true;}
    }
    return {price:local,sourcePrice,cartVariant:id,dedicated:!!o.dataset.cartVariant,unpriced};
  }
  function summary(root, choices) {
    const reduction = choices.reduce((n,o)=>n+(o.sourcePrice<0?o.sourcePrice:0),0);
    const id = reduction ? reductions(root)[String(reduction)] : baseId(root);
    const total = price(id) + choices.reduce((n,o)=>n+(o.sourcePrice>0?o.price:0),0);
    return {variant:id,total,sum:total-price(baseId(root))};
  }
  function stamp(props, base, extras) {
    const lines = [base,...extras.map(x=>x.id)].map(id=>[String(id),price(id)]);
    props['_Bockmann-Valuta']=currency();
    props['_Bockmann-Prisrader']=JSON.stringify(lines);
    props['_Bockmann-Konfigurationspris']=String(lines.reduce((n,row)=>n+row[1],0));
    props['_Bockmann-AntalTillval']=String(extras.length);
  }
  function labels(root) {
    root.querySelectorAll('option[data-price],input[data-option][data-price]').forEach(o=>{
      if(!Number(o.dataset.price))return;
      const result=option(root,o),text=result.unpriced?'Pris på förfrågan':(result.price>0?'+':'')+money(result.price);
      if(o.tagName==='OPTION')o.textContent=(o.dataset.label||o.value)+' ('+text+')';
      else {const target=o.closest('label')?.querySelector('small');if(target)target.textContent=text;}
    });
    root.querySelectorAll('.esprit-package-source').forEach(el=>{const text=el.firstChild;if(text?.nodeType===3)text.textContent='Paketpriser visas i '+currency()+'. ';});
  }
  async function prepare(root) {
    root.dataset.pricesReady='false';
    const add=root.querySelector('[data-add],[data-bp-add]'),error=root.querySelector('[data-error],[data-bp-error]');
    if(add){add.disabled=true;add.textContent='Hämtar aktuella priser…';}
    try {
      const handle=document.querySelector('[data-bk-shop]')?.dataset.product || decodeURIComponent(location.pathname.split('/products/')[1]?.split('/')[0] || '');
      await Promise.all([...handles,handle].map(h=>loadProduct(h)));
      price(baseId(root)); labels(root);root.dataset.pricesReady='true';return true;
    } catch(e) {if(error){error.textContent=e.message;error.hidden=false;}if(add)add.textContent='Ladda om sidan för att hämta priser';return false;}
  }
  window.EquistoreConfigPrices={currency,money,price,option,summary,stamp,prepare,loadProduct,labels};
})();
